import { forwardRef } from 'react';

import { Box, BoxProps } from '@vimeo/bokeh';

interface ModuleWrapperProps extends BoxProps {
  gridArea?: 'media' | 'playlist' | 'sideModule' | 'comments' | 'contentStack';
}

export const ModuleWrapper = forwardRef<HTMLDivElement, ModuleWrapperProps>((props, ref) => {
  return (
    <Box
      ref={ref}
      borderRadius="drawer"
      backgroundColor="surface"
      position="relative"
      w="100%"
      _empty={{
        display: 'none',
      }}
      {...props}
    />
  );
});
